import { actionKitImpFunction } from '../../../../../components/ozmoit/common';
import {
  getStudentSessionDetail,
  updateStudentSessionEnrollment,
} from '../api';
import { UpdateSessionFormFields } from '../types';

const getStudentSessionDetailAction = actionKitImpFunction(
  async (id: string) => {
    const response = await getStudentSessionDetail(id);
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    const { data } = response;
    return data;
  },
);

const updateStudentSessionEnrollmentAction = actionKitImpFunction(
  async (id: number, data: UpdateSessionFormFields) => {
    const response = await updateStudentSessionEnrollment(id, data);

    if (response.error) {
      throw new Error('Error updating enrollment');
    }
    return response.data;
  },
);

export { getStudentSessionDetailAction, updateStudentSessionEnrollmentAction };
